import { ArrowDownToLine, ArrowUpFromLine, Lock, ShieldOff } from "lucide-react";

function Acao({ icone: Icone, titulo, dica, onClick, principal, e2e, liberada = true }) {
  // Sem permissão (Pessoas › Funcionários): o botão fica, travado, com o motivo.
  if (!liberada) {
    return (
      <div className="rounded-2xl border border-dashed p-4 flex items-center gap-3 text-muted-foreground" data-e2e={`${e2e}-bloqueada`}>
        <span className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 bg-muted"><ShieldOff className="w-5 h-5" /></span>
        <span className="min-w-0"><span className="block font-bold">{titulo}</span><span className="block text-xs">Sem permissão — o dono libera em Pessoas › Funcionários</span></span>
      </div>
    );
  }
  return (
    <button type="button" onClick={onClick} data-e2e={e2e}
      className={`rounded-2xl border p-4 text-left flex items-center gap-3 transition-colors ${principal ? "bg-primary text-primary-foreground border-primary hover:bg-primary/90" : "bg-card hover:bg-muted/60"}`}>
      <span className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${principal ? "bg-white/20" : "bg-muted"}`}><Icone className="w-5 h-5" /></span>
      <span className="min-w-0">
        <span className="block font-bold">{titulo}</span>
        <span className={`block text-xs ${principal ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{dica}</span>
      </span>
    </button>
  );
}

/** Tirar dinheiro, colocar dinheiro, fechar — o que o operador faz no caixa. */
export default function AcoesCaixa({ onSangria, onSuprimento, onFechar, permissoes }) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Acao icone={ArrowUpFromLine} titulo="Tirar dinheiro" dica="Sangria: levar para o cofre, pagar algo" onClick={onSangria} e2e="acao-sangria" liberada={permissoes.movimentar} />
      <Acao icone={ArrowDownToLine} titulo="Colocar dinheiro" dica="Suprimento: reforçar o troco" onClick={onSuprimento} e2e="acao-suprimento" liberada={permissoes.movimentar} />
      <Acao icone={Lock} titulo="Fechar caixa" dica="Contar e conferir o turno" onClick={onFechar} principal e2e="acao-fechar" liberada={permissoes.fechar} />
    </div>
  );
}
